module.exports = __webpack_public_path__ + "static/media/Other-Banner.6d1091bd.jpg";